import { render, staticRenderFns } from "./EditorNavbar.vue?vue&type=template&id=64595d3a&"
import script from "./EditorNavbar.vue?vue&type=script&lang=ts&"
export * from "./EditorNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./EditorNavbar.vue?vue&type=style&index=0&id=64595d3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports